import React, { useEffect, useState } from "react";
import { useAuth } from "../../contexts/AuthContext";
import { getApi, deleteApi } from "../../utils/api/api";
import { showToast } from "../../utils/toast";
import { useNavigate } from "react-router-dom";
import { showConfirmationAlert } from "../../utils/confirmationAlert";
import { useLanguage } from "../../contexts/LanguageContext";
import Loader from "../../utils/loader";
import importImage from "../../utils/images/importImage";

const SpunImage = importImage("77.jpeg");
const FillImage = importImage("88.jpeg");


const ExistingInventory = () => {
  const { t } = useLanguage();
  const baseUrl = "https://backend.tokoyarn.com/public/";
  const { user } = useAuth();
  const navigate = useNavigate();
  const [inventories, setInventories] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchInventories = async () => {
    setLoading(true);
    try {
      const response = await getApi(
        `seller/get-inventory?userId=${user.user_data.id}`
      );
      for (const inventory of response.data.product.data) {
        if (inventory.images && inventory.images.length) {
          inventory.prevImages = JSON.parse(inventory.images);
          inventory.images = [];
        }
      }
      setInventories(response.data.product.data);
      console.log(response.data.product.data);
    } catch (err) {
      showToast("error", err.message || "Failed to fetch inventory.");
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (id) => {
    showConfirmationAlert({
      message: t("confirmation.delete", "Are you sure you want to delete?"),
      onConfirm: async () => {
        try {
          await deleteApi(`seller/delete-inventory/${id}`);
          showToast("success", "Inventory deleted successfully!");
          setInventories((prev) =>
            prev.filter((inventory) => inventory.id !== id)
          );
        } catch (err) {
          showToast("error", err.message || "Failed to delete inventory.");
        }
      },
      onCancel: () => {} // Added empty function as default for onCancel
    });
  };

  useEffect(() => {
    fetchInventories();
  }, []);

  const renderQualityBadge = (grade) => {
    const colors = {
      A: "success",
      B: "primary",
      C: "warning",
      D: "danger",
    };
    return (
      <span
        className={`badge bg-${colors[grade] || "secondary"} fs-6 shadow-sm`}
      >
        Grade {grade}
      </span>
    );
  };

  const renderProductSpecs = (inventory) => {
    if (inventory.type === "Spun" && inventory.spun) {
      return (
        <div className="row g-2">
          <div className="col-6">
            <strong>End Use:</strong> {inventory.spun.end_use}
          </div>
          <div className="col-6">
            <strong>Technology:</strong> {inventory.spun.technology}
          </div>
          <div className="col-6">
            <strong>Ply:</strong>{" "}
            {inventory.spun.ply}
          </div>
          <div className="col-6">
            <strong>Application:</strong>{" "}
            {inventory.spun.application}
          </div>
          <div className="col-6">
            <strong>Count:</strong>{" "}
            {inventory?.spun?.count_from} - {inventory?.spun?.count_to} 
          </div>
          <div className="col-6">
            <strong>IPI:</strong>{" "}
            {inventory.spun.ipi}
          </div>
        </div>
      );
    } else if (inventory.type === "Filament" && inventory.filament) {
      return (
        <div className="row g-2">
          <div className="col-6">
            <strong>Semi/Full Dull:</strong> {inventory.filament.dull}
          </div>
          <div className="col-6">
            <strong>Texturized:</strong> {inventory.filament.texturized}
          </div>
          <div className="col-6">
            <strong>Denier:</strong> {inventory.filament.dennier_from} - {inventory.filament.dennier_to}
          </div>
          <div className="col-6">
            <strong>No. Of Filament:</strong> {inventory.filament.filament_no_from} - {inventory.filament.filament_no_to}
          </div>
        </div>
      );
    }
    return null;
  };

  return (
    <div className="container py-4">
      <div className="d-flex flex-wrap justify-content-between align-items-center mb-4">
        <h2 className="text-primary fw-bold mb-2">Existing Inventory</h2>
        <button
          className="btn btn-primary d-flex align-items-center"
          onClick={() => navigate("/seller-dashboard/add-inventory")}
        >
          <i className="bi bi-plus-circle me-2"></i> Add New
        </button>
      </div>

      {loading ? (
        <Loader />
      ) : inventories.length > 0 ? (
        <div className="row g-4">
          {inventories.map((inventory) => (
            <div key={inventory.id} className="col-12">
              <div
                className="card border-0 shadow-lg flex-row flex-wrap align-items-stretch p-2"
                style={{
                  borderRadius: "12px",
                  transition: "0.3s",
                  overflow: "hidden",
                }}
              >
                {/* Image Section */}
                <div
                  className="col-12 col-md-4 p-2"
                  style={{ maxWidth: "350px" }}
                >
                  <img
                    src={
                      inventory.prevImages && inventory.prevImages.length
                        ? `${baseUrl}${inventory.prevImages[0]}`
                        : inventory.type === "Spun"
                        ? SpunImage
                        : FillImage
                    }
                    alt="Product"
                    className="w-100 h-100 rounded"
                    style={{
                      objectFit: "cover",
                      minHeight: "200px",
                      maxHeight: "250px",
                    }}
                  />
                </div>

                {/* Content Section */}
                <div className="col flex-grow-1 p-3 d-flex flex-column">
                  <div className="d-flex justify-content-between align-items-start mb-2">
                    <div>
                      <h5 className="card-title mb-1">
                        {inventory.type} Yarn
                      </h5>
                      <p className="text-muted small mb-0">
                        {inventory.type === "Spun"
                          ? `${inventory.spun?.category} ${
                              inventory.spun?.sub_category
                                ? `- ${inventory.spun.sub_category}`
                                : ""
                            }`
                          : inventory.filament?.category}
                      </p>
                    </div>
                    {renderQualityBadge(inventory.quality_grade)}
                  </div>

  {/*                  {inventory.type === "Filament" && (
  <p className="fw-bold text-success mb-2 fs-6">
    {`${inventory.filament.price_from} - ${inventory.filament.price_to}`} {inventory.price_type}
  </p>
)}*/}


                  <div className="mb-3">{renderProductSpecs(inventory)}</div>

                  <div className="mt-auto pt-3 border-top d-flex gap-2 flex-wrap">
                    <button
                      className="btn btn-outline-primary btn-sm"
                      onClick={() =>
                        navigate(
                          `/seller-dashboard/inventory-detail/${inventory.id}`,
                          { state: { inventory } }
                        )
                      }
                    >
                      <i className="bi bi-eye me-1"></i> View
                    </button>
                    <button
                      className="btn btn-outline-secondary btn-sm"
                      onClick={() =>
                        navigate(`/seller-dashboard/${inventory.id}`, {
                          state: { inventory },
                        })
                      }
                    >
                      <i className="bi bi-pencil me-1"></i> Edit
                    </button>
                    <button
                      className="btn btn-outline-danger btn-sm"
                      onClick={() => handleDelete(inventory.id)}
                    >
                      <i className="bi bi-trash me-1"></i> Delete
                    </button>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      ) : (
        <div className="text-center py-5">
          <i className="bi bi-box-seam display-4 text-muted mb-3"></i>
          <h4 className="text-muted">No inventories found</h4>
          <button
            className="btn btn-primary mt-3"
            onClick={() => navigate("/seller-dashboard/add-inventory")}
          >
            Add Your First Inventory
          </button>
        </div>
      )}
    </div>
  );
};

export default ExistingInventory;